export const isAndroid = () => /Android/i.test(navigator.userAgent)

export const isApple = () =>
    /(iPad|iPhone|Mac OS X|Macintosh)/i.test(navigator.userAgent)

export const hasMultiTouch = () => navigator.maxTouchPoints > 1

export const isMobileDevice = () =>
    isAndroid() || (isApple() && hasMultiTouch())
